import { useMemo } from 'react';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { upperCase } from 'lodash-es';

export const MultiLangName = (props: { source: string; fallback: string; className?: string }) => {
  const { source, fallback, ...rest } = props;
  const name = useKnowledgeName(source, fallback);
  return <div {...rest}>{name}</div>;
};

const useKnowledgeName = (source: string, fallback: string) => {
  let lang = useSystemLanguageValue();
  return useMemo(() => {
    return getMultiLangValue(source, lang, fallback);
  }, [source, fallback, lang]);
};

export const getMultiLangValue = (source: string, lang: string, fallback: string) => {
  if (!source) return fallback;
  if (lang === 'zh-CN') lang = 'cn';
  if (lang === 'en-US') lang = 'en';
  if (lang === 'vi') lang = 'vn';
  if (lang === 'tl') lang = 'ph';
  try {
    const parsed = JSON.parse(source);
    // 说明未更改过name, 返回多语言版本
    if (fallback === parsed['CN']) {
      return parsed[upperCase(lang)] || fallback;
    } else {
      // 返回更改过的name
      return fallback;
    }
  } catch (error) {
    return fallback;
  }
};

export default useKnowledgeName;
